import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Grid from '@mui/material/Grid'
import Switch from '@mui/material/Switch'
import TextField from '@mui/material/TextField'
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { apiService } from '../../api/axiosClient'
import Editor from '../../components/editor'
import Page from '../../components/Page'
import { FileUploaderSingle } from '../../components/upload'
import DropzoneWrapper from '../../styles/react-dropzone'
import { convertURLtoFile } from '../../utils/convertURLtoFile'

const Event = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [event, setEvent] = useState('')
    const [loading, setLoading] = useState(false)
    const [files, setFiles] = useState([])
    const [content, setContent] = useState('')
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm()

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get(`/events/${params.id}`)
            const payload = response.data;

            setEvent(payload.data)
        }

        fetchData().catch(e => console.error(e));
    }, [params.id]);

    useEffect(() => {
        const defaultValues = {
            title: event?.title,
            subtitle: event?.subtitle,
            finish: event?.finish == "10" ? true: false,
            expose: event?.expose == "10" ? true: false
        }
        reset(defaultValues)

        convertURLtoFile(event.imageUrl, setFiles)

        // callback editor
        setContent(event.content)

    }, [reset, event]);

    const goBack = () => {
        // createObjectURL를 통해 만들어진 url는 해당 브라우저가 존재한 상태에서 revokeObjectURL 메소드로 url을 무효화 시키지 않으면 
        // js 엔진에서 garbage collect를 시키지 않고 계속 변수가 남아 메모리 누수가 됩니다.
        // 그렇기 때문에 url 사용을 종료하면 revokeObjectURL 메소드를 사용하여 브라우저가 
        // 더이상 이 객체를 메모리에 들고 있지 않아도 된다고 알려야합니다.
        files.map(file => (
            URL.revokeObjectURL(file)
        ))

        navigate(-1)
    }

    const onSubmit = async (data, e) => {
        setLoading(true)

        const [file] = files;
        const formData = new FormData()

        formData.append('title', data.title);
        formData.append('subtitle', data.subtitle);
        formData.append('content', content);
        formData.append('finish', data.finish ? "10":"20");
        formData.append('expose', data.expose ? "10":"20");
        formData.append('file', file);

        await apiService.postFormData(`/events/${event.eventid}`, formData)
        .then(response => {
            toast.success('수정 되었습니다');
            goBack();
        }).finally(() => {
            setLoading(false)
        });
    }

    return (
        <Page title="Event">
            <Card>
                <Box component="form" onSubmit={handleSubmit(onSubmit)} id="eventform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                이벤트
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='title'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='제목'
                                                id='title'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.title)}
                                                helpertext={errors?.message}
                                                aria-describedby='validation-async-title'
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='subtitle'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='부제목'
                                                id='subtitle'
                                                onChange={onChange}
                                                placeholder='부제목을 입력해주세요'
                                                error={Boolean(errors.subtitle)}
                                                helpertext={errors?.message}
                                                aria-describedby='validation-async-subtitle'
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl>
                                    <Controller
                                        name='finish'
                                        control={control}                                            
                                        defaultValue={false}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='진행옵션'
                                                control={
                                                    <Switch checked={value} onChange={onChange} name='controlled' />
                                                }
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl>
                                    <Controller
                                        name='expose'
                                        control={control}                                            
                                        defaultValue={false}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='노출옵션'
                                                control={
                                                    <Switch checked={value} onChange={onChange} name='controlled' />
                                                }
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <Editor content={content} setContent={setContent} />
                            </Grid>

                            <Grid item xs={12}>
                                <DropzoneWrapper>
                                    <FileUploaderSingle files={files} setFiles={setFiles} />
                                </DropzoneWrapper>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Box>

                <CardActions className='card-action'>
                    <Button type="submit" form="eventform" variant='contained'>
                        {loading ? (
                            <CircularProgress
                                sx={{
                                    color: 'common.white',
                                    width: '20px !important',
                                    height: '20px !important',
                                    mr: theme => theme.spacing(2)
                                }}
                            />
                        ) : null}
                        수정
                    </Button>
                    <Button variant='outlined' color='secondary' onClick={goBack}>
                        취소
                    </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default Event